var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c93132;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #3174b8;\n      }\n\n      .cls-3 {\n        fill: #eaeae9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -2,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.8,73.1s-3.5,2,2.5,2.7c7.3.8,11,.7,19.1-.8,0,0,2.1,1.3,5.1,2.5-18,7.7-40.8-.4-26.7-4.4ZM27.6,63s-3.9,2.9,2.1,3.5c7.8.8,14,.9,24.6-1.2,0,0,1.5,1.5,3.8,2.3-21.8,6.4-46.1.5-30.5-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.2,45.9c4.4,5.1-1.2,9.7-1.2,9.7,0,0,11.3-5.8,6.1-13.1-4.8-6.8-8.6-10.2,11.5-21.8,0,0-31.6,7.9-16.5,25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.1,80.6s2.6,2.1-2.9,3.8c-10.4,3.2-43.3,4.1-52.5.1-3.3-1.4,2.9-3.4,4.8-3.8,2-.4,3.2-.4,3.2-.4-3.7-2.6-23.6,5.1-10.1,7.2,36.8,6,67.1-2.7,57.5-7h0ZM31.5,52.6s-16.8,4-5.9,5.4c4.6.6,13.7.5,22.2-.2,6.9-.6,13.9-1.8,13.9-1.8,0,0-2.4,1-4.2,2.3-17,4.5-49.9,2.4-40.4-2.2,8-3.9,14.5-3.4,14.5-3.4h0ZM61.6,69.4c17.3-9,9.3-17.6,3.7-16.5-1.4.3-2,.5-2,.5,0,0,.5-.8,1.5-1.1,11-3.9,19.5,11.4-3.6,17.5,0,0,.3-.2.3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.2,1.9s9.6,9.6-9.1,24.3c-15,11.8-3.4,18.6,0,26.3-8.7-7.9-15.1-14.8-10.8-21.3,6.3-9.5,23.8-14.1,19.9-29.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.2,93.7c16.6,1.1,42.1-.6,42.7-8.4,0,0-1.2,3-13.7,5.3-14.2,2.7-31.6,2.4-42,.6,0,0,2.1,1.8,13,2.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/Java.0f98acfea18910cb7590de9761f21277.svg";
export { ForwardRef as ReactComponent };